/* eslint-disable react/forbid-prop-types */
/* eslint-disable import/no-unresolved */
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import USBOptionButtonGroup from '@usb-inner-src/react-forms-group-option-button'
import USBBusinessNameInput from '@usb-ui-tools/react-forms-input-business-name'
import USBAccountNumberInput from '@usb-ui-tools/react-forms-input-account-number'
import USBPhoneInput from '@usb-inner-src/react-forms-input-phone'
import USBAddressCollection from '@usb-ui-tools/react-forms-collection-address'
import USBIconBuildings from '@usb-shield/react-icons/dist/esm/icon-buildings'
import USBIconProfile from '@usb-shield/react-icons/dist/esm/icon-profile'
import { BlockLayout } from '@usb-ui-tools/react-billpay-layout'

import { useMultilingualService } from '../../../../../service/multilingualService'
import {
  getFieldErrorMessage,
  incrementErrorCountsForFieldLevelError
} from '../../../../../utils/errorMapping'
import { isOLBOrIpadApp } from '../../../../../utils/browserutils'
import './manual-details.scss'

/**
 * Returns details information
 * @method
 * @param {Number} companyErrorCount - to render the error
 * @param {Number} accountNumberErrorCount - to render the error
 * @param {Number} personNameErrorCount - to render the error
 * @param {Object} companyRef - referance of company element
 * @param {Object} accountNumberRef - referance of account number element
 * @param {Object} personNameRef - referance of person element
 * @param {String} accountnumber - account number value
 * @param {Function} setCompanyTab - to set tab
 * @param {Function} handleStatusUpdate - handler for input update
 * @param {Function} setName - to set name
 * @param {Function} setAccountnumber - to set account number
 * @param {Function} setNickname - to set nick name
 * @param {Function} resetFormFields - to reset all the field value
 * @param {Object} intl - locale of DashboardNearbyMarchants
 * @param {Object} phoneNumberRef - referance of phone number element
 * @param {Number} phoneNumberErrorCount - to render the error
 * @param {Function} setPhonenumber - to set phone number
 * @param {Function} handleStatusUpdate - handler for input update
 * @param {Function} setAddress1 - to set Address1
 * @param {Function} setAddress2 - to set Address2
 * @param {Function} setCity - to set city
 * @param {Function} setState - to set state
 * @param {Function} setZipcode - to set zipcode
 * @param {Number} addressCollectionErrorCount - to render the error
 * @param {Object} addressCollectionRef - reference of the address element
 * @param {String} googleAPIkey - google api key for address
 * @param {Boolean} companyTab - tab view status
 * @param {Object} fieldLevelErrorData - field level error data object
 * @returns {HTMLElement} Returns segment with details information
 */
const Details = ({
  companyErrorCount,
  accountNumberErrorCount,
  personNameErrorCount,
  companyRef,
  accountNumberRef,
  personNameRef,
  companyTab,
  accountnumber,
  setCompanyTab,
  handleStatusUpdate,
  setName,
  setAccountnumber,
  setNickname,
  resetFormFields,
  fieldLevelErrorData,
  name = '',
  nickname = '',
  phoneNumberRef,
  phoneNumberErrorCount,
  setPhonenumber,
  setAddress1,
  setAddress2,
  setCity,
  setState,
  setZipcode,
  addressCollectionErrorCount,
  addressCollectionRef,
  googleAPIkey,
  phonenumber,
  address1Val,
  address2Val,
  cityVal,
  stateVal,
  zipcodeVal,
  formValues
  // buttonOptionStyle
  // stateZipAllignment
}) => {
  const { DETAILS } = useMultilingualService('addBillManual')
  const { CONTACT } = useMultilingualService('addBillManual')

  useEffect(() => {
    accountNumberRef?.current
      ?.querySelector('input')
      ?.classList?.add('glance_masked')
  }, [accountNumberRef, companyTab])

  return (
    <div className="manual-card">
      <BlockLayout actAs="shell" mobileTopMargin="0" mobileBottomMargin="24">
        <p
          id="addbill-manual-additional-info"
          style={{ paddingBottom: isOLBOrIpadApp() ? '1.5rem' : '' }}
          className="usb-tg-body-medium usb-c-gray-80"
        >
          You can find this information on your most recent statement.
        </p>
      </BlockLayout>
      <BlockLayout
        actAs="CardChild"
        // contentOnTop={
        //   <p className="usb-tg-body-medium usb-c-gray-80">
        //     You can find this information on your most recent statement.
        //   </p>
        // }
      >
        <div style={isOLBOrIpadApp() ? { width: '75%' } : { width: 'inherit' }}>
          <p
            id="add-bill-manual-instruction"
            className="usb-tg-subheader-large usb-c-usb-blue"
          >
            {DETAILS?.ADD_BILL_MANUALLY_PAY_INSTRUCTION}
          </p>
          <USBOptionButtonGroup
            id="add-bill-manual-chip-input"
            variant="stack"
            inputName="billertype"
            additionalClasses={['padding-columns']}
            legendText=""
            options={[
              {
                value: 'Company',
                label: 'Company',
                icon: <USBIconBuildings size="24" />
              },
              {
                value: 'Person',
                label: 'Person',
                icon: (
                  <USBIconProfile size="24" style={{ marginTop: '0.5px' }} />
                )
              }
            ]}
            errorMessages={{
              default: 'Please provide an option'
            }}
            statusUpdateCallback={() => {
              resetFormFields()
              setCompanyTab(!companyTab)
            }}
            dynamicValue={companyTab ? 'Company' : 'Person'}
          />
          <div
            style={isOLBOrIpadApp() ? { width: '100%' } : { width: 'inherit' }}
          >
            {companyTab ? (
              <USBBusinessNameInput
                id="add-bill-manual-business-input"
                ref={companyRef}
                inputName="business-name"
                pattern="[^a-zA-Z0-9_(){}&@!+#.$,'% *-]"
                labelText={DETAILS?.ADD_BILL_MANUALLY_COMPANY_NAME}
                statusUpdateCallback={(inputObj) => {
                  handleStatusUpdate(inputObj)
                  const { inputValue } = inputObj

                  setName(inputValue)
                }}
                errorMessages={{
                  default: DETAILS?.ADD_BILL_COMPANY_NAME_ERROR,
                  111: DETAILS?.ADD_BILL_FILTER_COMPANY_NAME_ERROR
                }}
                type="first"
                showFilterErrors
                dynamicErrorCount={companyErrorCount}
                dynamicValue={name}
                key={`${companyErrorCount}test`}
              />
            ) : (
              <USBBusinessNameInput
                id="add-bill-manual-name-input"
                ref={personNameRef}
                inputName="person-name"
                pattern="[^a-zA-Z0-9_(){}&@!+#.$,'% *-]"
                labelText={DETAILS?.ADD_BILL_MANUALLY_PERSON_NAME}
                statusUpdateCallback={(inputObj) => {
                  handleStatusUpdate(inputObj)
                  const { inputValue } = inputObj

                  setName(inputValue)
                }}
                errorMessages={{
                  default: DETAILS?.ADD_BILL_PERSON_NAME_ERROR,
                  111: DETAILS?.ADD_BILL_FILTER_PERSON_NAME_ERROR
                }}
                showFilterErrors
                type="first"
                dynamicErrorCount={personNameErrorCount}
                dynamicValue={name}
                key={`${personNameErrorCount}test`}
              />
            )}
            {companyTab ? (
              <>
                <USBAccountNumberInput
                  ref={accountNumberRef}
                  inputName="account-number"
                  labelText={DETAILS?.ADD_BILL_MANUALLY_ACC_NUMBER}
                  statusUpdateCallback={(inputObj) => {
                    handleStatusUpdate(inputObj)
                    const { inputValue } = inputObj

                    setAccountnumber(inputValue)
                  }}
                  errorMessages={{
                    default: getFieldErrorMessage(
                      DETAILS?.ADD_BILL_ACCOUNT_ERROR,
                      fieldLevelErrorData,
                      'accountnumber',
                      'addEditErrors'
                    ),
                    112: DETAILS?.ADD_BILL_FILTER_ACCOUNT_ERROR,
                    114: getFieldErrorMessage(
                      DETAILS?.ADD_BILL_ACCOUNT_ERROR,
                      fieldLevelErrorData,
                      'accountnumber',
                      'addEditErrors'
                    )
                  }}
                  showErrorMessage="every"
                  showFilterErrors
                  dynamicErrorCount={incrementErrorCountsForFieldLevelError(
                    fieldLevelErrorData,
                    'accountnumber',
                    accountNumberErrorCount
                  )}
                  initValue={accountnumber}
                />
              </>
            ) : (
              <USBAccountNumberInput
                id="add-bill-manual-acc-number-input"
                ref={accountNumberRef}
                inputName="account-number-person"
                labelText={DETAILS?.ADD_BILL_MANUALLY_ACC_NUMBER_OPT}
                statusUpdateCallback={(inputObj) => {
                  handleStatusUpdate(inputObj)
                  const { inputValue } = inputObj

                  setAccountnumber(inputValue)
                }}
                errorMessages={{
                  default: DETAILS?.ADD_BILL_ACCOUNT_ERROR,
                  112: DETAILS?.ADD_BILL_FILTER_ACCOUNT_ERROR
                }}
                showErrorMessage="every"
                showFilterErrors
                dynamicErrorCount={accountNumberErrorCount}
                dynamicValue={accountnumber}
                isOptional
              />
            )}
            <USBBusinessNameInput
              id="add-bill-manual-nick-name-input"
              inputName="nick-name"
              pattern="[^a-zA-Z0-9 ,.'-]"
              labelText={DETAILS?.ADD_BILL_MANUALLY_NICK_NAME}
              statusUpdateCallback={(inputObj) => {
                const { inputValue } = inputObj

                setNickname(inputValue)
              }}
              errorMessages={{
                default: `${DETAILS?.ADD_BILL_NICK_NAME_ERROR}`
              }}
              showFilterErrors
              type="first"
              isOptional
              dynamicValue={nickname || ''}
            />
            <USBPhoneInput
              id="add-bill-manual-contact-input"
              ref={phoneNumberRef}
              inputName="phone-input"
              labelText={
                companyTab
                  ? CONTACT?.ADD_BILL_MANUALLY_MERCHANT_PHONE
                  : CONTACT?.ADD_BILL_MANUALLY_PERSON_PHONE
              }
              errorMessages={{
                default: companyTab
                  ? `${CONTACT?.ADD_BILL_PHONR_ERROR_COMPANY}`
                  : `${CONTACT?.ADD_BILL_PHONR_ERROR_PERSON}`,
                121: `${CONTACT?.ADD_BILL_PHONR_ERROR_121}`,
                201: `${CONTACT?.ADD_BILL_PHONR_ERROR_201}`
              }}
              statusUpdateCallback={(inputObj) => {
                handleStatusUpdate(inputObj)
                const { inputValue } = inputObj
                setPhonenumber(inputValue)
              }}
              dataTestId="test-id"
              showFilterErrors
              dynamicValue={phonenumber}
              dynamicErrorCount={phoneNumberErrorCount}
              key={
                companyTab
                  ? CONTACT?.ADD_BILL_MANUALLY_MERCHANT_PHONE
                  : CONTACT?.ADD_BILL_MANUALLY_PERSON_PHONE
              }
            />
            <USBAddressCollection
              id="add-bill-manual-address-section"
              ref={addressCollectionRef}
              apiKey={googleAPIkey}
              physicalAddressRequired={false}
              useStateSelect
              variant="state-zip-compress"
              key={
                companyTab
                  ? `${addressCollectionErrorCount}company`
                  : `${addressCollectionErrorCount}person`
              }
              initValues={[
                {
                  field: 'address1',
                  value: address1Val
                },
                {
                  field: 'address2',
                  value: address2Val
                },
                {
                  field: 'city',
                  value: cityVal
                },
                {
                  field: 'state',
                  value: stateVal
                },
                {
                  field: 'postalCode',
                  value: zipcodeVal
                }
              ]}
              dynamicValues={[
                {
                  field: 'address1',
                  value: address1Val
                },
                {
                  field: 'address2',
                  value: address2Val
                },
                {
                  field: 'city',
                  value: cityVal
                },
                {
                  field: 'state',
                  value: stateVal
                },
                {
                  field: 'postalCode',
                  value: zipcodeVal
                }
              ]}
              collectionContent={[
                {
                  field: 'address1',
                  label: `${
                    companyTab
                      ? CONTACT?.ADD_BILL_MANUALLY_MERCHANT_ADDRESS
                      : CONTACT?.ADD_BILL_MANUALLY_PERSON_ADDRESS
                  }`,
                  errors: {
                    default: getFieldErrorMessage(
                      CONTACT?.ADD_BILL_STREET_ERROR,
                      fieldLevelErrorData,
                      'addressLine1',
                      'addEditErrors'
                    ),
                    114: getFieldErrorMessage(
                      CONTACT?.ADD_BILL_STREET_ERROR,
                      fieldLevelErrorData,
                      'addressLine1',
                      'addEditErrors'
                    )
                  }
                },
                {
                  field: 'address2',
                  label: `${CONTACT?.ADD_BILL_MANUALLY_APT}`,
                  errors: {
                    default: `${CONTACT?.ADDBILL_ADDRESS2_ERROR}`
                  }
                },
                {
                  field: 'city',
                  label: `${CONTACT?.ADD_BILL_MANUALLY_CITY}`,
                  errors: {
                    default: getFieldErrorMessage(
                      CONTACT?.ADD_BILL_CITY_ERROR,
                      fieldLevelErrorData,
                      'city',
                      'addEditErrors'
                    ),
                    114: getFieldErrorMessage(
                      CONTACT?.ADD_BILL_CITY_ERROR,
                      fieldLevelErrorData,
                      'city',
                      'addEditErrors'
                    )
                  }
                },
                {
                  field: 'state',
                  // label: `${CONTACT?.ADD_BILL_MANUALLY_STATE}`,
                  label: '',
                  placeholder: 'State',
                  errors: {
                    default: getFieldErrorMessage(
                      CONTACT?.ADD_BILL_STATE_ERROR,
                      fieldLevelErrorData,
                      'state',
                      'addEditErrors'
                    ),
                    114: getFieldErrorMessage(
                      CONTACT?.ADD_BILL_STATE_ERROR,
                      fieldLevelErrorData,
                      'state',
                      'addEditErrors'
                    )
                  }
                },
                {
                  field: 'postalCode',
                  label: `${CONTACT?.ADD_BILL_MANUALLY_ZIP}`,
                  errors: {
                    default: getFieldErrorMessage(
                      CONTACT?.ADD_BILL_ZIPCODE_ERROR,
                      fieldLevelErrorData,
                      'zipcode',
                      'addEditErrors'
                    ),
                    114: getFieldErrorMessage(
                      CONTACT?.ADD_BILL_ZIPCODE_ERROR,
                      fieldLevelErrorData,
                      'zipcode',
                      'addEditErrors'
                    )
                  }
                },
                {
                  field: 'county',
                  label: 'County',
                  errors: {
                    default: 'Custom error text'
                  }
                }
              ]}
              statusUpdateCallback={(addressObj) => {
                const newObj = { ...addressObj }
                if (newObj.address1 === '') {
                  newObj.address1 = {
                    inputValue:
                      formValues?.addressCollection?.address1?.inputValue,
                    errorCode: 0
                  }
                }
                if (newObj.address2 === '') {
                  newObj.address2 = {
                    inputValue:
                      formValues?.addressCollection?.address2?.inputValue,
                    errorCode: 0
                  }
                }
                if (newObj.city === '') {
                  newObj.city = {
                    inputValue: formValues?.addressCollection?.city?.inputValue,
                    errorCode: 0
                  }
                }
                if (newObj.state === '') {
                  newObj.state = {
                    inputValue:
                      formValues?.addressCollection?.state?.inputValue,
                    errorCode: 0
                  }
                }
                if (newObj.postalCode === '') {
                  newObj.postalCode = {
                    inputValue:
                      formValues?.addressCollection?.postalCode?.inputValue,
                    errorCode: 0
                  }
                }
                const {
                  address1: { inputValue: address1 = '' },
                  address2: { inputValue: address2 = '' },
                  city: { inputValue: city = '' },
                  state: { inputValue: state = '' },
                  postalCode: { inputValue: postalCode = '' }
                } = addressObj
                handleStatusUpdate({ ...newObj })
                setAddress1(
                  address1 !== ''
                    ? address1
                    : formValues?.addressCollection?.address1?.inputValue
                )
                setAddress2(
                  address2 !== ''
                    ? address2
                    : formValues?.addressCollection?.address2?.inputValue
                )
                setCity(
                  city !== ''
                    ? city
                    : formValues?.addressCollection?.city?.inputValue
                )
                setState(
                  state !== ''
                    ? state
                    : formValues?.addressCollection?.state?.inputValue
                )
                setZipcode(
                  postalCode !== ''
                    ? postalCode
                    : formValues?.addressCollection?.postalCode?.inputValue
                )
              }}
              showFilterErrors
              collectionErrorCounts={[
                {
                  field: 'address1',
                  dynamicErrorCount: incrementErrorCountsForFieldLevelError(
                    fieldLevelErrorData,
                    'addressLine1',
                    addressCollectionErrorCount
                  )
                },
                {
                  field: 'address2',
                  dynamicErrorCount: addressCollectionErrorCount
                },
                {
                  field: 'city',
                  dynamicErrorCount: incrementErrorCountsForFieldLevelError(
                    fieldLevelErrorData,
                    'city',
                    addressCollectionErrorCount
                  )
                },
                {
                  field: 'state',
                  dynamicErrorCount: incrementErrorCountsForFieldLevelError(
                    fieldLevelErrorData,
                    'state',
                    addressCollectionErrorCount
                  )
                },
                {
                  field: 'postalCode',
                  dynamicErrorCount: incrementErrorCountsForFieldLevelError(
                    fieldLevelErrorData,
                    'zipcode',
                    addressCollectionErrorCount
                  )
                },
                {
                  field: 'county',
                  dynamicErrorCount: addressCollectionErrorCount
                }
              ]}
            />
          </div>
        </div>
      </BlockLayout>
    </div>
  )
}

Details.propTypes = {
  companyErrorCount: PropTypes.number.isRequired,
  accountNumberErrorCount: PropTypes.number.isRequired,
  personNameErrorCount: PropTypes.number.isRequired,
  companyRef: PropTypes.objectOf(PropTypes.any).isRequired,
  accountNumberRef: PropTypes.objectOf(PropTypes.any).isRequired,
  personNameRef: PropTypes.objectOf(PropTypes.any).isRequired,
  companyTab: PropTypes.bool.isRequired,
  accountnumber: PropTypes.string.isRequired,
  setCompanyTab: PropTypes.func.isRequired,
  handleStatusUpdate: PropTypes.func.isRequired,
  setName: PropTypes.func.isRequired,
  setAccountnumber: PropTypes.func.isRequired,
  setNickname: PropTypes.func.isRequired,
  resetFormFields: PropTypes.func.isRequired,
  nickname: PropTypes.string,
  name: PropTypes.string.isRequired,
  fieldLevelErrorData: PropTypes.objectOf(PropTypes.any).isRequired,
  phoneNumberRef: PropTypes.objectOf(PropTypes.any).isRequired,
  phoneNumberErrorCount: PropTypes.number.isRequired,
  setPhonenumber: PropTypes.func.isRequired,
  address1Val: PropTypes.string,
  address2Val: PropTypes.string,
  cityVal: PropTypes.string,
  stateVal: PropTypes.string,
  zipcodeVal: PropTypes.string,
  setAddress1: PropTypes.func.isRequired,
  setAddress2: PropTypes.func.isRequired,
  setCity: PropTypes.func.isRequired,
  setState: PropTypes.func.isRequired,
  setZipcode: PropTypes.func.isRequired,
  addressCollectionErrorCount: PropTypes.number.isRequired,
  addressCollectionRef: PropTypes.objectOf(PropTypes.any).isRequired,
  googleAPIkey: PropTypes.string.isRequired,
  phonenumber: PropTypes.string,
  formValues: PropTypes.objectOf(PropTypes.any).isRequired
  // buttonOptionStyle: PropTypes.objectOf(PropTypes.any).isRequired,
  // stateZipAllignment: PropTypes.objectOf(PropTypes.any).isRequired
}
Details.defaultProps = {
  nickname: '',
  phonenumber: '',
  address1Val: '',
  address2Val: '',
  cityVal: '',
  stateVal: '',
  zipcodeVal: ''
}

export default Details
